import type { RouteLocationRaw } from "vue-router";

/**
 * Where a visitor lands when they arrive at the portal root.
 *
 * A signed-out visitor at "/" used to be bounced straight to the sign-in form,
 * which told a first-time citizen nothing about what the portal is for. They
 * now see the public welcome page instead.
 *
 * Only the bare root changes. Every other protected path is a deep link, most
 * often an email button for one application, and those must keep going to
 * login with `redirect` so the citizen is put back where the email pointed.
 * This returns null for them and the existing requiresAuth rule takes over.
 *
 * The guard sees `to.path === "/"` for a direct visit to "/" (with or without
 * a query): the matched leaf is the empty-path child `home-index`, so the
 * parent's redirect never rewrites the path.
 */
export function frontDoor(
  toPath: string,
  loggedIn: boolean
): RouteLocationRaw | null {
  if (loggedIn) return null;
  // Tolerate a fullPath too: "/?utm_source=sms" is still the front door.
  if (toPath.split(/[?#]/)[0] !== "/") return null;
  return { name: "welcome" };
}
